import * as React from 'react';
import { default as MuiTooltip, TooltipProps as MuiTooltipProps } from '@material-ui/core/Tooltip';
import styled from 'styled-components';
import { TooltipProps } from './Tooltip.types';

export const shouldEnableTooltip = (el: HTMLElement | null): boolean => (el ? el.scrollWidth > el.clientWidth : false);

export const Tooltip: React.FC<React.PropsWithChildren<TooltipProps>> = (props) => {
  const { dataTest, title, children, disabled, compact = true, dark, tooltipTargetProps, ...rest } = props;

  if (disabled) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  return (
    <StyledTooltip
      dark={dark}
      data-test={dataTest}
      compact={compact}
      PopperProps={{ style: { opacity: 1 } }}
      {...rest}
      enterDelay={300}
      title={title}
    >
      <span {...tooltipTargetProps}>{children}</span>
    </StyledTooltip>
  );
};

const StyledTooltip = styled(
  ({ className, dark, compact, ...props }: MuiTooltipProps & { dark?: boolean; compact?: boolean }) => (
    <MuiTooltip placement="top" {...props} classes={{ tooltip: className }} />
  )
)`
  && {
    margin: ${({ compact }) => (compact ? 0 : undefined)};
  }
`;

export default Tooltip;
